const cropzoneToGeoJSONFeature = cropzone => ({
  type: 'Feature',
  geometry: cropzone?.geometry,
  properties: {
    name: cropzone?.name
  }
});

export default cropzoneToGeoJSONFeature;
